import React from "react"
import { SiCodechef, SiLeetcode, SiHashnode } from "react-icons/si"

const About = () => {
    return (
      <div>
        <section class="resume-section" id="about">
          <div class="resume-section-content">
            <h1 class="mb-0">
              Varun
              <span class="text-primary">Agarwal</span>
            </h1>
            <div class="subheading mb-5">
              Backend and Devops Guy ·
              <a href="mailto:varunagarwal10.2@gmail.com">
                varunagarwal10.2@gmail.com
              </a>
            </div>
            <p class="lead mb-5">
            I’m Varun Agarwal, a backend developer with a strong focus on building scalable systems and APIs. I have hands-on experience with Django, FastAPI, AWS, and Docker. Currently, I’m working at PocketFM as an SDE-1. I’ve previously interned at TechStack and DAO Studio. Alongside full-time roles, I also work as a freelancer, delivering robust fullstack solutions. I enjoy solving complex problems and bringing efficient systems to life.
            </p>
            <div class="social-icons">
              <a
                class="social-icon"
                href="https://www.linkedin.com/in/1010varun/"
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
              <a class="social-icon" href="https://github.com/1010varun">
                <i class="fab fa-github"></i>
              </a>
              <a class="social-icon" href="https://twitter.com/1010varun_">
                <i class="fab fa-twitter"></i>
              </a>
              <a
                class="social-icon"
                href="https://www.codechef.com/users/varun_aga1010"
              >
                <SiCodechef />
              </a>
              <a class="social-icon" href="https://leetcode.com/1010varun/">
                <SiLeetcode />
              </a>
              <a class="social-icon" href="https://1010varun.hashnode.dev/">
                <SiHashnode />
              </a>
            </div>
          </div>
        </section>
      </div>
    );
}

export default About;